import React, { useMemo } from 'react';
import { Text } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

export interface HeaderGreetingProps {
  fontSize?: string;
  fontWeight?: number | string;
  className?: string;
}

const HeaderGreeting: React.FC<HeaderGreetingProps> = ({
  fontSize = 'md',
  fontWeight = 500,
  className,
}) => {
  const { t } = useTranslation();
  const user = useSelector((state: any) => state.authorization?.user);

  const fullName = useMemo(() => {
    const INVALID = new Set(['null', 'undefined', '']);
    const clean = (v: any): string =>
      String(v ?? '')
        .split(' ')
        .map(w => w.trim())
        .filter(w => !INVALID.has(w))
        .join(' ');
    const first = clean(user?.firstName);
    const last = clean(user?.lastName);
    return `${first} ${last}`.trim() || clean(user?.fullName);
  }, [user?.firstName, user?.lastName, user?.fullName]);

  const greeting = useMemo(() => {
    const h = new Date().getHours();
    if (h < 12) return t('greeting.morning');
    if (h < 18) return t('greeting.afternoon');
    return t('greeting.evening');
  }, [t]);

  return (
    <Text fontSize={fontSize} fontWeight={fontWeight} className={className}>
      {`${greeting}${fullName ? `, ${fullName}` : ''}`}
    </Text>
  );
};

export default HeaderGreeting;
